import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Badge from 'components/Badge/Badge';
import { Link } from 'react-router-dom';

import { Create, Add, BeenhereRounded, Visibility } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGet, wsGetAll } from 'services/WService.js';

import ModalLine from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Opciones', accessor: 'options', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Categorías', accessor: 'category' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions' },
];

export default WithApp(function Line(props) {
  const { categoryId } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [category, setCategory] = useState(undefined);
  const [lines, setLines] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadLines() {
    setDataLoading(true);
    let response = await wsGetAll('logi/line');
    setDataLoading(false);
    if (response.success) setLines(response.data);
  }

  async function loadCategory() {
    setDataLoading(true);
    let response = await wsGet('logi/category', categoryId);
    setDataLoading(false);

    if (!response.success) return;

    let { lines, ...category } = response.data;
    setCategory(category);
    setLines(lines || []);
  }

  useEffect(() => {
    if (categoryId !== undefined) {
      loadCategory();
    } else {
      loadLines();
    }
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalLine model={model} setOpen={setOpen} showNotify={showNotify} reload={loadLines} />
      <GridItem xs={12}>
        <Card>
          {categoryId === undefined ? (
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.LOGI_LINES_STORE}
                component={
                  <CardIcon color="primary">
                    <BeenhereRounded style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <CardIcon
                  onClick={() => setOpen({})}
                  pointer="true"
                  color={props.themeContext.buttonColorSuccess}
                >
                  <Add />
                </CardIcon>
              </AllowedGuard>
              <h4 className={classes.cardIconTitle}>Listado de Líneas {dataLoading && <LoadingSpinner />}</h4>
            </CardHeader>
          ) : (
            <CardHeader>
              {category !== undefined ? (
                <Badge color="info">{category.business_partner?.CardName}</Badge>
              ) : undefined}
              <h3 className={classes.cardIconTitle}>
                {category === undefined
                  ? 'Cargando categoría...'
                  : `Categoría ${category.description}`}
              </h3>
            </CardHeader>
          )}
          <CardBody>
            {category !== undefined ? <h5>Líneas</h5> : undefined}
            <ReactTable
              excelName="Líneas"
              defaultWidth={1000}
              indexRow={[0, 1, 2, 5, 6]}
              widthRow={[50, 150, 100, 150, 5]}
              columns={columns}
              data={lines.map((line, i) => {
                return {
                  num: i + 1,
                  options: (
                    <Fragment>
                      <AllowedGuard permission={ConstantPermissions.LOGI_LINES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(line)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>

                      <Button justIcon round simple color="primary">
                        <Link to={`/admin/articulos/datos-maestros/lineas/${line.id}`}>
                          <Visibility />
                        </Link>
                      </Button>

                      <AllowedGuard permission={ConstantPermissions.LOGI_LINES_DELETED}>
                        <ButtonDelete entity="logi/line" id={line.id} reload={loadLines} />
                      </AllowedGuard>
                    </Fragment>
                  ),
                  code: line.code,
                  description: line.description,
                  category: line.logi_category_description,
                  state: line.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
